var _circle, _circle2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBifma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 46,
    fill: "#EFF6FF",
    stroke: "#0EA5E9",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 30,
    fill: "#DC2626"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 47,
    textAnchor: "middle",
    fontFamily: "Segoe UI, Arial",
    fontSize: 13,
    fontWeight: 800,
    fill: "#FFFFFF"
  }, "BIFMA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 61,
    textAnchor: "middle",
    fontFamily: "Segoe UI, Arial",
    fontSize: 8,
    fontWeight: 700,
    fill: "#FFFFFF"
  }, "COMPLIANCE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBifma);
export default __webpack_public_path__ + "static/media/bifma.5d3cd6fd8bd6c88a0a9210b8fdeac3d9.svg";
export { ForwardRef as ReactComponent };